import { readingSteps } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

export default function ReadingGuide() {
  return (
    <section id="reading" className="w-full bg-background-50 px-4 md:px-6 py-16 md:py-24">
      <div className="max-w-6xl mx-auto">
        <SectionHeading
          eyebrow="阅读指南"
          title="四步走，从陌生到稳定追更"
          desc="定位只是第一步。真正省时间的是养成一套固定流程：先缩范围，再试读，最后用标签沉淀口味。"
        />

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {readingSteps.map((item, idx) => (
            <article key={item.step} className="relative rounded-lg border border-background-200 bg-background-100/70 p-5 md:p-6">
              <div className="flex items-center gap-3">
                <span className="w-10 h-10 rounded-full flex items-center justify-center font-heading font-bold bg-accent-500 text-background-50">
                  {item.step}
                </span>
                {idx < readingSteps.length - 1 && (
                  <span className="hidden lg:block flex-1 h-px bg-background-300"></span>
                )}
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{item.title}</h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{item.desc}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}